<div id=fullPage>
  <div class="col-lg-4 col-md-6  col-sm-6 col-xs-12 nopadding">
    <app-exceptioncount></app-exceptioncount>
  </div>
  <div class=" col-lg-4 col-md-6 col-sm-6 col-xs-12 nopadding">
    <app-transactioncount></app-transactioncount>
  </div>
  <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 nopadding">
    <app-transaction-exception-summary></app-transaction-exception-summary>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 nopadding">
    <app-exception-summary-count-list></app-exception-summary-count-list>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 nopadding">
    <app-system-log-summary></app-system-log-summary>
  </div>
</div>